import React from "react";
import PropTypes from "prop-types";

const ProhibitedMedicationsPage = () => {
  return (
    <div
      style={{
        fontFamily: "Arial",
        fontSize: "12pt",
        padding: "25px",
        lineHeight: "1.5",
        height: "1210px",
      }}
    >
      {/* Title */}
      <div style={{ textAlign: "center" }}>
        <h2
          style={{
            fontFamily: "Arial",
            fontSize: "14pt",
            fontWeight: "bold",
            paddingBottom: "5px",
            borderBottom: "2px solid black",
            display: "inline-block",
          }}
        >
          PROHIBETED OVER THE COUNTED MEDICATIONS, ETC
        </h2>
      </div>

      {/* Prohibited Medications Content */}
      <div style={{ marginBottom: "15px", padding: "40px" }}>
        <p style={{ marginBottom: "15px" }}>
          WELLBUTRIN / GABAPENTIN / IMODIUM ARE PROHIBITED ON THE RESIDENTIAL
          PROPERTY AT LEGACY HEALING CENTER DUE TO THE MEDICAL RISK OF SEIZURES
          AND OVERDOSE IF ABUSED. MEDICATIONS WILL BE HEALD AND OBSERVED UPON
          PRESCRIBED DOSES AT THE CLINICAL BUILDING. ALL CLIENTS ARE RESPONSIBLE
          FOR COMING TO TAKE MEDICINES AT SCHEDULED TIMES.
        </p>
        <div style={{ marginBottom: "15px", padding: "20px" }}>
          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            ANY ITEMS CONTAINING ALCOHOL (ROBITUSSIN, NYQUIL, Z-QUIL, AND MOST
            COUGH SYRUPS)
          </p>

          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            ANY ITEMS CONTAINING DEXTRAMETHORPHAN (COMMON DXM-CONTAINING COUGH
            MEDICINES INCLUDE MANY FORMS OF ALKA-SELZER PLUS, COMTREX,
            CORICIDIN, DELSYM, DIMETAPP, MUCINEX, PEIDACARE, ROBITUSSIN,
            THERAFLU, TRIAMINIC, TYLENOL COUGH & COLD, VICKS COUGH & COLD, VICKS
            DAYQUIL/NYQUIL, VICKS FORMULA 44 AND MORE, INCLUDING STORE BRAND
            VERSIONS OF THESE PRODUCTS)
          </p>

          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            ANY ITEMS CONTAINING EPHEDRA OR EPHEDRINE (SUDAFED OR DIET PILLS)
          </p>

          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            ANY ITEMS CONTAINING LOPERAMIDE (IMMODIUM)
          </p>

          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            ANY CREATINE, PRO-HORMONE TESTOSTERONE OR PRE-WORKOUT SUPPLEMENTS
            .... (NO STEROIDS)
          </p>

          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            NO KOMBUCHA
          </p>

          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            NO KAVA/KRATOM
          </p>

          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            NO PILLS, VITAMINS OR HERBAL SUPPLEMENTS CONTAINING STIMULANTS OR
            CAFFEINE
          </p>

          <p style={{ marginBottom: "15px", fontWeight: "bold" }}>
            NO MEDICAL MARIJUANA
          </p>
        </div>
      </div>
    </div>
  );
};

ProhibitedMedicationsPage.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
};

export default ProhibitedMedicationsPage;
